const defaultExtraProps = (userUID, response = undefined) => {
  let defaultExtraPropsObj = [
    {
      type: 'tag',
      key: 'product',
      value: 'doubts'
    },
    {
      type: 'tag',
      key: 'flowType',
      value: 'learner'
    },
    {
      type: 'user',
      key: 'userUID',
      value: userUID
    },
    {
      type: 'tag',
      key: 'userUID',
      value: userUID
    }
  ];
  if (response) {
    defaultExtraPropsObj = [
      ...defaultExtraPropsObj,
      {
        type: 'context',
        key: 'response',
        value: response
      }
    ];
  }
  return defaultExtraPropsObj;
};
export default defaultExtraProps;
